<template>
  <section class="mobile-separator-image-container">
    <div class="content-wrapper">
    </div>
  </section>
</template>

<script>
export default {
  name: "MobileSeparatorImage"
}
</script>

<style scoped>
  .mobile-separator-image-container {
    display: none;
    height: 60vw;
    padding-top: 40px;
  }

  .content-wrapper {
    height: 100%;
    background-image: url("../assets/brand_photos/hero.png");
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media only screen and (max-width: 700px) {
    .mobile-separator-image-container {
      display: block;
    }
  }
</style>
